import { render, staticRenderFns } from "./SegmentosDialog.vue?vue&type=template&id=24f6e2ce"
import script from "./SegmentosDialog.vue?vue&type=script&lang=js"
export * from "./SegmentosDialog.vue?vue&type=script&lang=js"
import style0 from "./SegmentosDialog.vue?vue&type=style&index=0&id=24f6e2ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports